//import _default from "keen-slider";

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InspectorControls,
        InnerBlocks
    } = window.wp.editor;

    const { 
        PanelBody, 
        TextControl,
    } = window.wp.components;

    const ALLOWED_BLOCKS = ['custom-gutenberg/experiences-slide'];

    registerBlockType('custom-gutenberg/experiences-slider', {
        // built-in attributes
        title: 'Experiences Slider',
        description: 'Custom Experiences Slider',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        attributes: {
            id: {
                default: Math.round(Math.random()*100)
            }
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                id
            } = attributes;

            const MY_TEMPLATE = [
                [ 'custom-gutenberg/experiences-slide', {} ],
            ];

            function onIdChange(id) {
                setAttributes({id: id});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <p><strong>Slider ID</strong></p>
                        <TextControl value={ id } onChange={ onIdChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <div className="experiences-slider-wrapper position-relative">
                    <div id={ 'xperiences-slider-' + id } className="een-slider" style={ { opacity: '1' } } data-sliderId={ id }>
                        <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } />
                    </div>
                    <div className="xperiences-slider-footer" data-sliderId={ id }>
                        <div className="container">
                            <div data-dir="prev" data-sliderId={ id }><i className="fa-light fa-arrow-left fa-lg"></i></div>
                            <div className="slider-count">
                                <span className="current-slide"></span>/<span className="slide-count"></span>
                            </div>
                            <div data-dir="next" data-sliderId={ id }><i className="fa-light fa-arrow-right fa-lg"></i></div>
                        </div>
                    </div>
                </div>
            ]);
        },

        save({ attributes }) {

            const {
                id
            } = attributes;

            return (
                <div className="experiences-slider-wrapper position-relative">
                    <div id={ 'experiences-slider-' + id } className="keen-slider" data-sliderId={ id }>
                        <InnerBlocks.Content />
                    </div>
                    <div className="experiences-slider-footer" data-sliderId={ id }>
                        <div className="container">
                            <div data-dir="prev" data-sliderId={ id }><i className="fa-light fa-arrow-left fa-lg"></i></div>
                            <div className="slider-count">
                                <span className="current-slide"></span>/<span className="slide-count"></span>
                            </div>
                            <div data-dir="next" data-sliderId={ id }><i className="fa-light fa-arrow-right fa-lg"></i></div>
                        </div>
                    </div>
                </div>
            );
        },
    });
}